import { render, staticRenderFns } from "./SummaryTab.vue?vue&type=template&id=265f0d40&"
import script from "./SummaryTab.vue?vue&type=script&lang=ts&"
export * from "./SummaryTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports